import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe, I18NextService } from 'angular-i18next';
import { ButtonComponent, InputComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { ToastService } from 'mbs-ui-kit/toast/toast.service';
import { ComputerBackupFacade } from 'mbs-ui-shared@facades/computer.backup.facade';
import { PlanInfo } from 'mbs-ui-shared@models/backup/plan-info-model';
import Computer from 'mbs-ui-shared@models/Computer';
import { ComputerPlanBasedModal } from 'mbs-ui-shared@models/ComputersModals';
import { of } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-clone-plan-modal',
  templateUrl: './clone-plan-modal.component.html',
  standalone: true,
  imports: [ButtonComponent, FormsModule, ReactiveFormsModule, ModalComponent, I18NextPipe, InputComponent, ModalFooterDirective]
})
export class ClonePlanModalComponent implements ComputerPlanBasedModal, OnInit {
  i18nextService = inject(I18NextService);
  i18nPipe = inject(I18NextPipe);
  private facade = inject(ComputerBackupFacade);
  private toast = inject(ToastService);

  public computer: Computer;
  public plan: PlanInfo;
  public loading = false;

  @ViewChild(ModalComponent, { static: true }) private baseModal;

  public clonePlanForm: UntypedFormGroup = new UntypedFormGroup({
    cloneName: new FormControl('')
  });

  ngOnInit(): void {
    this.clonePlanForm.setValue({ cloneName: '' });
  }

  /**
   * Set clone name
   */
  handleResolve(): void {
    const cloneName = this.clonePlanForm.get('cloneName').value;

    this.loading = true;

    this.facade
      .clonePlan(this.computer, this.plan?.id, cloneName)
      .pipe(
        map(() => true),
        catchError(() => {
          return of(false);
        }),
        tap(() => {
          this.loading = false;
        }),
        filter(Boolean)
      )
      .subscribe(() => {
        this.facade.loadPlans({ computer: this.computer, force: true });
        this.toast.success(`The plan has been cloned`);
        this.baseModal.close();
      });
  }
}
